import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import {DeliveryOrderService, XpressPaymentTransactionService} from 'app/services';
import {ChatMessageTypeEnum, OrderRiderActionEnum} from 'app/models';
import * as moment from 'moment';
import { Utils } from 'app/utils';

enum MenuTab {
    OrderDetails = 1,
    Products = 2,
    Messages = 3,
    Timeline = 4
}

@Component({
    selector: 'customer-order-detail',
    templateUrl: './customer-order-detail.component.html',
    styleUrls: ['./customer-order-detail.component.scss',
        '../../../../../../styles/sidebar.scss',
        '../../../../../../styles/style-layout.scss'
    ]
})
export class CustomerOrderDetailComponent implements OnInit {
    public transactionId!: number;
    @Input()
    set _transactionId(value: number) {
        this.transactionId = value;
        if (this.transactionId > 0) {
            this.getTransactionByIdAdmin();
        }
    }

    @Input()
    public isVisibleCustomerOrderDetail: boolean = false;

    @Output() changedVisibleCustomerOrderDetailEmit = new EventEmitter<boolean>();
    changedVisibleCustomerOrderDetail(increased: any) {
        this.changedVisibleCustomerOrderDetailEmit.emit(increased);
    }

    public showSpinner: boolean = false;

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.OrderDetails;

    public transaction: any = undefined;

    public chatMessageTypeEnum = ChatMessageTypeEnum;

    public orderStats: any;

    constructor(
        private messageService: MessageService,
        private xpressPaymentTransactionService: XpressPaymentTransactionService,
        private deliveryOrderService: DeliveryOrderService
    ) { }

    public menuItems: MenuItem[] = [
        {
            label: 'Details',
            id: `${MenuTab.OrderDetails}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Messages',
            id: `${MenuTab.Messages}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Timeline',
            id: `${MenuTab.Timeline}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
    ];

    ngOnInit(): void {
    }

    public handleMenuTabChange(menuTab: MenuTab) {
        this.activeMenuTab = menuTab;
    }

    public getTransactionByIdAdmin() {
        this.showSpinner = true;
        const dto = {
            TransactionId: this.transactionId,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.xpressPaymentTransactionService.getTransactionByIdAdmin(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.showSpinner = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.transaction = data;
                if (this.transaction.Messages) {
                    this.transaction.Messages.map((item: any) => {
                        item.CreatedAt = moment(item.CreatedAt).format('DD.MM.YYYY h:mm');
                    });
                }
                this.transaction.TransactionDate = (this.transaction.TransactionCreatedAt) ? moment(this.transaction.TransactionCreatedAt).format('DD MMM YYYY') : '';
                this.transaction.TransactionTime = (this.transaction.TransactionCreatedAt) ? moment(this.transaction.TransactionCreatedAt).format('h:mm:ss A') : '';
                this.transaction.TransactionAmount = (this.transaction.TransactionAmount < 0) ?
                    '₱' + -this.transaction.TransactionAmount : '₱' + this.transaction.TransactionAmount;
                this.transaction.DeliveryCreatedAt = (this.transaction.DeliveryCreatedAt) ? moment(this.transaction.DeliveryCreatedAt).format('DD MMM YYYY, h:mm A') : '';
                this.transaction.DeliveryCompletedAtDate = (this.transaction.DeliveryCompletedAt) ?
                    moment(this.transaction.DeliveryCompletedAt).format('DD MMM YYYY') : '';
                this.transaction.DeliveryCompletedAtTime = (this.transaction.DeliveryCompletedAt) ?
                    moment(this.transaction.DeliveryCompletedAt).format('h:mm A') : '';

                this.transaction.AcceptedAtTime = (this.transaction.AcceptedAt) ? moment(this.transaction.AcceptedAt).format('h:mm A') : '';
                this.transaction.ArrivedToPickupAtTime = (this.transaction.ArrivedToPickupAt) ? moment(this.transaction.ArrivedToPickupAt).format('h:mm A') : '';
                this.transaction.ArrivedToDropAtTime = (this.transaction.ArrivedToDropAt) ? moment(this.transaction.ArrivedToDropAt).format('h:mm A') : '';

                this.transaction.TimeAccepted = (this.transaction.AcceptedAt) ? moment(this.transaction.AcceptedAt).format('h:mm') : '';
                this.transaction.TimeArrivalPickup = (this.transaction.ArrivedToPickupAt) ? moment(this.transaction.ArrivedToPickupAt).format('h:mm') : '';
                this.transaction.TimeArrivalDropOff = (this.transaction.ArrivedToDropAt) ? moment(this.transaction.ArrivedToDropAt).format('h:mm') : '';
                this.transaction.CompletedAt = (this.transaction.CompletedAt) ? moment(this.transaction.CompletedAt).format('h:mm') : '';

                if (this.transaction.OrderProcessings) {
                    this.transaction.OrderProcessings.map((item: any) => {
                        item.CreatedAt = moment(item.CreatedAt).format('hh:mm:ss');
                    });
                }
                this.getOrderDetail();

                this.showSpinner = false;
            })
            .catch(err => {
                this.showSpinner = false;
                throw err;
            });
    }

    private getOrderDetail() {
        const dto = {
            TransactionId: this.transaction.Id
        };

        this.deliveryOrderService.getOrderDetailsByTransactionId(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.orderStats = data;
                this.orderStats.CreatedAt = Utils.utcToLocalDate(this.orderStats.CreatedAt);
                this.orderStats.AcceptedTime = (this.orderStats.AcceptedAt) ? moment(Utils.utcToLocalDate(this.orderStats.AcceptedAt)).format('hh:mm') : '';
                this.orderStats.PackingStartedAt = this.orderStats.PackingStartedAt ? Utils.utcToLocalDate(this.orderStats.PackingStartedAt) : '';
                this.orderStats.ReadyToDispatchAt = this.orderStats.ReadyToDispatchAt ? Utils.utcToLocalDate(this.orderStats.ReadyToDispatchAt) : '';
                this.orderStats.DispatchDateTime = this.orderStats.DispatchAt ? Utils.utcToLocalDate(this.orderStats.DispatchAt) : '';
                this.orderStats.DispatchTime = this.orderStats.DispatchAt ? moment(Utils.utcToLocalDate(this.orderStats.DispatchAt)).format('hh:mm') : '';
                this.orderStats.DeliveredDateTime = this.orderStats.DeliveredAt ? Utils.utcToLocalDate(this.orderStats.DeliveredAt) : '';
                this.orderStats.DeliveredTime = this.orderStats.DeliveredAt ? moment(Utils.utcToLocalDate(this.orderStats.DeliveredAt)).format('hh:mm') : '';
                this.orderStats.CompletedAt = this.orderStats.CompletedAt ? Utils.utcToLocalDate(this.orderStats.CompletedAt) : '';
                this.orderStats.CompletedTime = (this.orderStats.CompletedAt) ? moment(this.orderStats.CompletedAt).format('hh:mm') : '';
                this.orderStats.CanceledAt = this.orderStats.CanceledAt ? Utils.utcToLocalDate(this.orderStats.CanceledAt) : '';
                this.orderStats.RiderAssignedDateTime = (this.orderStats.RiderAssignedAt) ? Utils.utcToLocalDate(this.orderStats.RiderAssignedAt) : '';
                this.orderStats.RiderAssignedTime = (this.orderStats.RiderAssignedAt) ?
                    moment(Utils.utcToLocalDate(this.orderStats.RiderAssignedAt)).format('hh:mm') : '';
                this.orderStats.ArrivedToPickupDateTime = (this.orderStats.ArrivedToPickupAt) ?
                    Utils.utcToLocalDate(this.orderStats.ArrivedToPickupAt) : '';
                this.orderStats.ArrivedToPickupTime = (this.orderStats.ArrivedToPickupAt) ?
                    moment(Utils.utcToLocalDate(this.orderStats.ArrivedToPickupAt)).format('hh:mm') : '';
                if (this.orderStats.RiderActions) {
                    this.orderStats.RiderActions.forEach((item: any) => {
                        item.CreatedDateTime = (item.CreatedAt) ? Utils.utcToLocalDate(item.CreatedAt) : '';
                        item.CreatedTime = (item.CreatedAt) ? moment(Utils.utcToLocalDate(item.CreatedAt)).format('hh:mm.ss') : '';
                    });
                    this.orderStats.RiderDropoffActions = this.orderStats.RiderActions
                        .filter((f: any) => (f.OrderRiderAction === OrderRiderActionEnum.ArrivedToDrop || f.OrderRiderAction === OrderRiderActionEnum.Completed));
                }
            });

    }

    cancel() {
        this.changedVisibleCustomerOrderDetail(false);
    }

    protected readonly orderRiderActionEnum = OrderRiderActionEnum;
}
